(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mk-size-guide"] && !Shopify.designMode) return;
  try {
    class MkSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.SIZE_MAP = {
        'XS':   { FR: '34', UK: '6',  US: '2'  },
        'S':    { FR: '36', UK: '8',  US: '4'  },
        'M':    { FR: '38', UK: '10', US: '6'  },
        'L':    { FR: '40', UK: '12', US: '8'  },
        'XL':   { FR: '42', UK: '14', US: '10' },
        'XXL':  { FR: '44', UK: '16', US: '12' },
        'XXXL': { FR: '46', UK: '18', US: '14' }
      };
      this.STORAGE_COUNTRY = 'mk_size_country';
      this.STORAGE_UNIT = 'mk_size_unit';
    }

    connectedCallback() {
      try {
        this.rows = JSON.parse(this.dataset.rows || '[]');
      } catch (e) {
        this.rows = [];
      }
      this.hasCols = {
        poitrine: this.dataset.hasPoitrine === 'true',
        longueur: this.dataset.hasLongueur === 'true',
        manches: this.dataset.hasManches === 'true',
        epaules: this.dataset.hasEpaules === 'true'
      };

      this.country = this._restore(this.STORAGE_COUNTRY, 'FR');
      this.unit = this._restore(this.STORAGE_UNIT, 'cm');

      this.countrySelect = this.querySelector('.mk-size-guide__country');
      this.unitButtons = this.querySelectorAll('.mk-size-guide__unit');
      this.tbody = this.querySelector('.mk-size-guide__tbody');

      if (!this.tbody) return;

      if (this.countrySelect) {
        this.countrySelect.value = this.country;
        this.countrySelect.addEventListener('change', (e) => {
          this.country = e.target.value;
          this._persist(this.STORAGE_COUNTRY, this.country);
          this._renderRows();
        });
      }

      this.unitButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const u = btn.dataset.unit;
          if (u === this.unit) return;
          this.unit = u;
          this._persist(this.STORAGE_UNIT, this.unit);
          this._updateUnitButtons();
          this._renderRows();
        });
      });

      this._updateUnitButtons();
      this._renderRows();
    }

    _restore(key, fallback) {
      try {
        const v = sessionStorage.getItem(key);
        return v || fallback;
      } catch (e) {
        return fallback;
      }
    }

    _persist(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) { /* indisponible : tant pis */ }
    }

    _updateUnitButtons() {
      this.unitButtons.forEach((btn) => {
        const active = btn.dataset.unit === this.unit;
        btn.classList.toggle('mk-size-guide__unit--active', active);
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
      });
    }

    _convertSize(label) {
      // Retourne la conversion régionale du label, ou null si non mappable
      if (label == null) return null;
      const key = String(label).trim().toUpperCase();
      const mapping = this.SIZE_MAP[key];
      if (!mapping) return null;
      return mapping[this.country] || null;
    }

    _formatValue(val) {
      if (val === null || val === undefined || val === '') return '—';
      const num = parseFloat(val);
      if (isNaN(num)) return '—';
      if (this.unit === 'inch') {
        const inches = num * 0.3937;
        const rounded = Math.round(inches * 2) / 2;
        return rounded % 1 === 0 ? String(rounded) : rounded.toFixed(1);
      }
      const r = Math.round(num * 10) / 10;
      return r % 1 === 0 ? String(r) : r.toFixed(1);
    }

    _renderRows() {
      const cols = this.hasCols;
      const frag = document.createDocumentFragment();

      this.rows.forEach((row) => {
        const tr = document.createElement('tr');

        // Colonne 1 : Taille (lettre Shopify, fixe)
        const tdSize = document.createElement('td');
        tdSize.className = 'mk-size-guide__td mk-size-guide__td--size';
        tdSize.textContent = row.label;
        tr.appendChild(tdSize);

        // Colonne 2 : Conversion régionale (FR/UK/US)
        const tdCountry = document.createElement('td');
        tdCountry.className = 'mk-size-guide__td mk-size-guide__td--country';
        const converted = this._convertSize(row.label);
        tdCountry.textContent = converted !== null ? converted : '—';
        tr.appendChild(tdCountry);

        // Colonnes mesures (uniquement celles qui ont des données quelque part)
        const appendCell = (key) => {
          if (!cols[key]) return;
          const td = document.createElement('td');
          td.className = 'mk-size-guide__td';
          td.textContent = this._formatValue(row[key]);
          tr.appendChild(td);
        };
        appendCell('poitrine');
        appendCell('longueur');
        appendCell('manches');
        appendCell('epaules');

        frag.appendChild(tr);
      });

      this.tbody.innerHTML = '';
      this.tbody.appendChild(frag);
    }
  }

  if (!customElements.get('mk-size-guide')) {
    customElements.define('mk-size-guide', MkSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
